import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import useStore from "../../lib/store";

const ITEMS = [
  { key: "d", label: "Dashboard", action: "navigate", route: "/" },
  { key: "a", label: "About", action: "navigate", route: "/about" },
  { key: "p", label: "Projects", action: "navigate", route: "/projects" },
  { key: "r", label: "Resume", action: "navigate", route: "/resume" },
  { key: "c", label: "Contact", action: "navigate", route: "/contact" },
  { key: "/", label: "Search (Telescope)", action: "search" },
  { key: ":", label: "Command mode", action: "command" },
  { key: "t", label: "Toggle theme", action: "theme" },
  { key: "?", label: "Toggle keymap help", action: "none" },
];

const WhichKey = () => {
  const navigate = useNavigate();
  const {
    whichKeyVisible,
    closeWhichKey,
    openSearch,
    openCommandMode,
    toggleTheme,
  } = useStore();
  const itemsRef = useRef(ITEMS);

  useEffect(() => {
    if (!whichKeyVisible) return;
    const handler = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        closeWhichKey();
        return;
      }
      const item = itemsRef.current.find((i) => i.key === e.key);
      if (!item) return;
      e.preventDefault();
      closeWhichKey();
      switch (item.action) {
        case "navigate":
          navigate(item.route);
          break;
        case "search":
          openSearch();
          break;
        case "command":
          openCommandMode();
          break;
        case "theme":
          toggleTheme();
          break;
        default:
          break;
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [whichKeyVisible, closeWhichKey, navigate, openSearch, openCommandMode]);

  return (
    <AnimatePresence>
      {whichKeyVisible && (
        <motion.div
          className="whichkey-backdrop"
          onClick={closeWhichKey}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.1 }}
        >
          <motion.div
            className="whichkey"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.12 }}
          >
            <div className="whichkey-title">Which Key — press a key</div>
            <div className="whichkey-grid">
              {ITEMS.map((item) => (
                <div key={item.key} className="whichkey-item">
                  <kbd className="whichkey-key">{item.key}</kbd>
                  <span className="whichkey-label">{item.label}</span>
                </div>
              ))}
            </div>
            <div className="whichkey-footer">esc to close</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WhichKey;
